import TopSpender from './top_spender';

export default {
    TopSpender
};
